import { CriticalVariableAssociatedRiskFields as RiskFields } from '@queries/generated/fragments.generated';

export enum RisksReviewsChipValues {
    Risks = 1,
    FunctionalDataReviews = 2,
}

export interface CtqPageRiskFields extends Omit<
    RiskFields,
    'status' | 'reviewStatus' | 'owner' | 'createdBy' | 'updatedBy'
> {
    status: string;
    reviewStatus: string;
    owner: {
        firstName: string | null;
        lastName: string | null;
        name: string | null;
        active: boolean | null;
    };
    createdBy: string;
    updatedBy: string;
}
